export enum ConfigValidationErrorTypes {
  FieldConstraintsError = 'FieldConstraintsError',
  RequiredConfigError = 'RequiredConfigError',
  InvalidInputError = 'InvalidInputError',
  ConfigArrayNumberOfElementsError = 'ConfigArrayNumberOfElementsError',
  DuplicateArrayNameError = 'DuplicateArrayNameError',
}
export const AllConfigValidationErrorTypes = Object.values(ConfigValidationErrorTypes);

export interface ValidationError {
  type: ConfigValidationErrorTypes;
  message: string;
}

export interface ValidationResult {
  errors: Array<ValidationError>;
}

export interface SubdependencyConfigValidation {
  [name: string]: ValidationResult;
}

export type DependencyConfigValidation = ValidationResult & {
  subdependencyValidation: SubdependencyConfigValidation;
  outputSubdependencyValidation: SubdependencyConfigValidation; // These are for workflows outputs only
};

export interface ConfigurationsValidation {
  [name: string]: DependencyConfigValidation;
}

export interface ArrayElementValidation {
  validation: ConfigurationsValidation;
  arrayName: string;
  arrayElementName: string;
}

export interface ArrayElementsValidation {
  [key: string]: ArrayElementValidation | null;
}

export interface UpdateArrayElementValidationCallback {
  (arrayElementKey: string, newArrayElementValidation: ArrayElementValidation | null): void;
}
